module.exports = __webpack_public_path__ + "static/media/person-icon.1b3ef2c9.svg";